<template>
  <div class="foot_main">
    <div class="footer_top">
      <!-- <div class="search_box">
        <p class="text">首页</p>
        <div class="seach_input flex">
          <input type="text" placeholder="输入关键词" />
          <i class="el-icon-search"></i>
        </div>
      </div> -->
      <div class="menu_list">
       <ul class="menu_item">
          <p>学院概况</p>
          <div>
            <li><a href="javascript:;">学院简介</a></li>
          <li><a href="javascript:;">学院沿革</a></li>
          <li><a href="javascript:;">学院领导</a></li>
          <!-- <li><a href="javascript:;">领导题词</a></li> -->
          <li><a href="javascript:;">学术交流</a></li>
          </div>
        </ul>
        <ul class="menu_item">
          <p>学习平台</p>
         <div>
           <li @click="goIndex('/course/list')"><a href="javascript:;">选课中心 </a></li>
          <li @click="goIndex('/course/liveIndex')"><a href="javascript:;">直播公开课</a></li>
          <li @click="goIndex('/course/dggj')"><a href="javascript:;">大连工匠专区</a></li>
          <li @click="goIndex('/course/jpk')"><a href="javascript:;">精品课程 </a></li>
          <li @click="goIndex('/subject/list')"><a href="javascript:;">线上专题课 </a></li>
          <li @click="goIndex('/offline_course/list')"><a href="javascript:;">线下专题课</a></li>
         </div>
        </ul>
        <ul class="menu_item">
          <p>创新工作</p>
         <div>
           <li @click="goIndex('/achievement/index')"><a href="javascript:;">创新成果</a></li>
          <li @click="goIndex('/studio/list')"><a href="javascript:;">创新工作室</a></li>
          <li @click="goIndex('/project/index')"><a href="javascript:;">创新项目</a></li>
          <li @click="goIndex('/gjrc/list')"><a href="javascript:;">工匠人才</a></li>
          <li @click="goIndex('/problem/index')"><a href="javascript:;">疑难攻关</a></li>
         </div>
        </ul>
        <ul class="menu_item">
          <p>技能竞赛</p>
          <div>
            <li @click="goIndex('/skills/index')"><a href="javascript:;">技能竞赛</a></li>
          </div>
        </ul>
      </div>
    </div>
    <div class="copy_code_box">
      <div class="copy_code">
        <div class="left_text ">
          <p>Copyright © 2015-2025 kjcxchina.com All Rights Reserved | 京ICP备16012224号

</p>
          <p>技术支持：中工科创</p>
        </div>
        <!-- <div class="right_menu flex">
          <p>
            <a href="javascript:;">联系我们</a>
          </p>
          <p>
            <a href="javascript:;">法律声明</a>
          </p>
          <p>
            <a href="javascript:;">隐私政策</a>
          </p>
          <p>
            <a href="javascript:;">除名查询</a>
          </p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      dataInfo: "",
      maskState: false,
    };
  },
  props: {
    deepLogoUrl: {
      type: String,
      default: "",
    },
    maskState1: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.foot_main {
  width: 100%;
  // height: 395px;
  background: #f2f2f2;
 
  // margin-top: 120px;
  .footer_top {
     box-sizing: border-box;
     padding: 63px 15px 0;
    .search_box {
      p.text {
        border-bottom: 1px solid #e2e2e2;
        padding-bottom: 23px;
        font-size: 15px;
        color: #333333;
      }
      .seach_input {
        margin-top: 21px;
        width: 100%;
        height: 45px;
        background: #ffffff;
        border: 1px solid #d4d4d4;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 20px;
        i {
          border-left: 1px solid #d4d4d4;
          padding-left: 20px;
          font-size: 20px;
        }
      }
    }
    .menu_list {
      margin-top: 33px;
      .menu_item{
        margin-bottom: 19px;
        p{
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            margin-bottom: 21px;
        }
        div{
            display: flex;
            flex-wrap: wrap;
            li{
                margin-right: 30px;
                margin-bottom: 27px;
                a{
                    font-size: 14px;
                    color: #333333;
                }
            }
        }
      }
    }
  }
  .copy_code_box{
    background: #E6E6E6;
    box-sizing: border-box;
    padding: 38px 15px;
    height: 154px;
    .left_text{
        p{
            font-size: 14px;
            color: #333333;
        }
    }
    .right_menu{
        margin-top: 26px;
        p{
            margin-right: 23px;
        }
        p:last-child{
            margin-right: 0;
        }
    }
  }
}
</style>
